// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { ReactElement } from 'react';

import { Route } from 'react-router-dom';

import { TrainingStore } from '../pages/I.LAB';

function TrainingStoreRoutes(): ReactElement {
  return (
    <>
      <Route
        path="/ilab/training-store/list/:segmentName"
        exact
        component={TrainingStore.TrainingStoreList}
      />
      <Route
        path="/ilab/training-store/profile-code-list/:profileCodeId"
        exact
        component={TrainingStore.ProfileCodeList}
      />
      <Route path="/ilab/training-store" exact component={TrainingStore.Main} />
      <Route
        path="/ilab/training-store/edit/:trainingStoreId"
        exact
        component={TrainingStore.EditTrainingStore}
      />
    </>
  );
}

export default TrainingStoreRoutes;
